import CUSTOM_SECTION_TYPE from '@src/quince-site-common/src/domains/CustomSectionType'

import ProductPageSectionProps from '../../domains/ProductPageSectionProps'
import FaqSection from '../../organisms/productPageCustomSections/faqSection/FaqSection'
import FullBleedMedia from '../../organisms/productPageCustomSections/fullBleedMedia'
import ImageWithScale from '../../organisms/productPageCustomSections/imageWithScale'
import ImageWithTextProductDetailsSection from '../../organisms/productPageCustomSections/imageWithTextProductDetailsSection/ImageWithTextProductDetailsSection'
import ProductComparisonSection from '../../organisms/productPageCustomSections/productComparisonSection/ProductComparisonSection'
import RowOfImageTextBlocks from '../../organisms/productPageCustomSections/rowOfImageTextBlocks'
import SocialPhotos from '../../organisms/productPageCustomSections/socialPhotos/SocialPhotos'
import StackedNewLongForm from '../../organisms/productPageCustomSections/stackedNewLongForm'
import TextBlockWithIconRowSection from '../../organisms/productPageCustomSections/textBlockWithIconRowSection'
import BrandComparison from '../../organisms/productPageSections/brandComparison/BrandComparison'
import Disclaimer from '../../organisms/productPageSections/disclaimer/Disclaimer'
import FrequentlyBoughtTogether from '../../organisms/productPageSections/frequentlyBoughtTogether/FrequentlyBoughtTogether'
import PairWithProducts from '../../organisms/productPageSections/pairWithProducts/PairWithProducts'
import ProductDetailsAndCare from '../../organisms/productPageSections/productDetailsAndCare/ProductDetailsAndCare'
import ProductImages from '../../organisms/productPageSections/productImages/ProductImages'
import ProductPurchase from '../../organisms/productPageSections/productPurchase/ProductPurchase'
import { ProductReviewsWrapper } from '../../organisms/productPageSections/productReviews/ProductReviews'
import ReviewHighlights from '../../organisms/productPageSections/reviewHighlights/ReviewHighlights'
import SimilarProducts from '../../organisms/productPageSections/similarProducts/SimilarProducts'
import TransparentPricing from '../../organisms/productPageSections/transparentPricing/TransparentPricing'
import YouMayAlsoLike from '../../organisms/productPageSections/youMayAlsoLike/YouMayAlsoLike'
import { ProductSectionType } from '../../types/productPage.types'

export const SECTION_TYPES_VS_RENDERER: Record<string, (props: ProductPageSectionProps) => JSX.Element | null> = {
  [ProductSectionType.PRODUCT_IMAGES]: ProductImages,
  [ProductSectionType.PRODUCT_PURCHASE]: ProductPurchase,
  [ProductSectionType.PRODUCT_DETAILS_AND_CARE]: ProductDetailsAndCare,
  [ProductSectionType.BRAND_COMPARISON]: BrandComparison,
  [ProductSectionType.PAIR_WITH]: PairWithProducts,
  [ProductSectionType.FREQUENTLY_BOUGHT_TOGETHER]: FrequentlyBoughtTogether,
  [ProductSectionType.SIMILAR_PRODUCTS]: SimilarProducts,
  [ProductSectionType.TRANSPARENT_PRICING]: TransparentPricing,
  [ProductSectionType.PRODUCT_REVIEWS]: ProductReviewsWrapper,
  [ProductSectionType.YOU_MAY_ALSO_LIKE]: YouMayAlsoLike,
  [ProductSectionType.REVIEW_HIGHLIGHTS]: ReviewHighlights,
  [ProductSectionType.MINI_SIMILAR_PRODUCTS]: SimilarProducts,
  [ProductSectionType.DISCLAIMER]: Disclaimer,
}

export const CUSTOM_SECTION_TYPES_VS_RENDERER: Record<string, (props: ProductPageSectionProps) => JSX.Element | null> =
  {
    [CUSTOM_SECTION_TYPE.INFLUENCER]: SocialPhotos,
    [CUSTOM_SECTION_TYPE.INFORMATION_BOXES]: FaqSection,
    [CUSTOM_SECTION_TYPE.FEATURE_SECTION_2]: ImageWithTextProductDetailsSection,
    [CUSTOM_SECTION_TYPE.FEATURE_SECTION_4]: ImageWithScale,
    [CUSTOM_SECTION_TYPE.FEATURE_SECTION_7]: ProductComparisonSection,
    [CUSTOM_SECTION_TYPE.FEATURE_SECTION_7_NEW]: ProductComparisonSection,
    [CUSTOM_SECTION_TYPE.FULL_BLEED_MEDIA]: FullBleedMedia,
    [CUSTOM_SECTION_TYPE.TEXT_BLOCK_WITH_ICON_ROW]: TextBlockWithIconRowSection,
    [CUSTOM_SECTION_TYPE.ROW_OF_IMAGE_TEXT_BLOCKS]: RowOfImageTextBlocks,
    [CUSTOM_SECTION_TYPE.STACKED_NEW_LONG_FORM]: StackedNewLongForm,
  }
